import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import React from 'react';
import { EntityCard } from '@finect/tabular-components/EntityCard';
import { getProductPath } from '@finect/front-resources/Products';
import { Mention } from '../commons';
export var EntityProduct = function EntityProduct(_ref) {
  var product = _ref.product,
    children = _ref.children;
  var id = product.id,
    subtype = product.subtype,
    name = product.name;
  var path = getProductPath({
    entity: product,
    subtype: subtype
  });
  var link = path !== '#' && path || product.url || product.web || product.link || product.entity && product.entity.web || null;
  var url = link && (link.includes('http') ? link : "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com').concat(link));
  return React.createElement(EntityCard, {
    type: "product",
    entity: {
      id: id,
      name: name || product.title || product.entity && product.entity.name,
      subtype: subtype
    }
  }, React.createElement(Mention, {
    href: url && (url.includes('undefined') || url.startsWith('#')) ? null : url
  }, children));
};